import * as CubeTree from '../../../cubeTree/index';
import * as UIToolkit from '../../../UIToolkit/index';
import Config from '../../../config/index';
import Utils from '../../../utils/util';
import Service from '../../../service/index';
import Select from '../../select/index';
import Visit from '../../visit';
import { updateCubeList } from '../../../update/updateCubeList';
import { runForceUpdate } from '../../../update/runForceUpdate';
import { updateEnd } from '../../../update/updateEnd';

interface MoveSubOutParams {
    subAddInfo: FreeObjMap,
    subSku: SkuData,
    mainCube: CubeNode,
    copySubList: SkuData[],
    currentRenderData: FreeObjMap
}

// 撤销
async function addSubStackOut(stackOutItem: StackOutItem|null): Promise<void> {
    let subAddInfo: FreeObjMap = stackOutItem.data[0];
    let mainGoodsCubeId: CubeId = subAddInfo.to;
    let mainGoodsCubeNode: CubeNode = CubeTree.findByCubeId(mainGoodsCubeId);
    let subList: SkuData[] = CubeTree.getCubeValueById(mainGoodsCubeId, 'subSkuList');
    let copySubList: SkuData[] = Utils.deepCopy(subList);
    let dragIndex: number = subAddInfo.subIndex + 1;
    let subSku: SkuData = subList.splice(dragIndex, 1)[0];
    let stageWindow: StageWindow = window;
    let currentRenderData: FreeObjMap = stageWindow.R_WIN_ATTR.getRenderData(1);
    let checkResult: FreeObjMap = moveCheck(mainGoodsCubeNode, subList, currentRenderData);

    if (checkResult.code !== '0000') {
        // 放弃移动
        removeGiveUp(mainGoodsCubeNode, copySubList, currentRenderData);
        return;
    }

    UIToolkit.showLoading();

    try {
        let addCubes: CubeId[] = await moveSubOut({
            subAddInfo,
            subSku,
            copySubList,
            currentRenderData,
            mainCube: mainGoodsCubeNode
        });
        let updateList: CubeId[] = makeUpdateList(addCubes[0], subAddInfo.to);

        Select.clear();
        Select.addGroup(addCubes);
        Select.panelSelectAsync();
        updateCubeList(updateList);
        updateEnd();
    }
    catch(err) {
        // 放弃移动
        removeGiveUp(mainGoodsCubeNode, copySubList, currentRenderData);
        UIToolkit.tips('移动失败');
    }

    UIToolkit.hideLoading();
}

function makeUpdateList(addCube: CubeId, fromCube: CubeId): CubeId[] {
    let result: Set<CubeId> = new Set();

    result.add(CubeTree.findParentIdByCubeId(addCube));
    result.add(CubeTree.findParentIdByCubeId(fromCube));

    return Array.from(result);
}

async function moveSubOut(params: MoveSubOutParams): Promise<CubeId[]> {
    let stageWindow: StageWindow = window;
    let paperId: number = Config.get({
        moduleName: 'base',
        key: 'paperId'
    });
    let hasSizeError: boolean = CubeTree.goodsInfoHasSizeError(params.subAddInfo.addCube);

    if (hasSizeError) {
        UIToolkit.tips('子码商品没有尺寸信息不能添加到图纸上');
        removeGiveUp(params.mainCube, params.copySubList, params.currentRenderData);
        return;
    }

    let addTaskList: InsertInfo = makeInsertTask(params.subAddInfo);
    let addCube: CubeId[] = await Visit.Add.runNormalInsert([addTaskList]);

    return addCube;
}

function makeInsertTask(subAddInfo: FreeObjMap): InsertInfo {
    let insertIndex: number = 0;
    let parent: CubeId = subAddInfo.oldParent;

    if (subAddInfo.before) {
        parent = CubeTree.findParentIdByCubeId(subAddInfo.before);
        insertIndex = CubeTree.getCubeIndexInParent(subAddInfo.before);
    }
    else {
        insertIndex = CubeTree.findChildCubeIds(parent).length;
    }

    return {
        insertData: subAddInfo.addCube,
        parentId: parent,
        index: insertIndex
    };
}

function removeGiveUp(cube: CubeNode, subList: SkuData[], currentRenderData: FreeObjMap): void {
    let stageWindow: StageWindow = window;

    stageWindow.FILTER_OF_STAGECORE.panelPreCheck([cube], 1, {
        key: 'subSkuList',
        value: subList
    }, currentRenderData);
}

function moveCheck(mainGoodsCubeNode: CubeNode, subList: SkuData[], currentRenderData: FreeObjMap): FreeObjMap {
    let stageWindow: StageWindow = window;
    let checkResult: FreeObjMap = stageWindow.FILTER_OF_STAGECORE.panelPreCheck([mainGoodsCubeNode], 1, {
        key: 'subSkuList',
        value: subList,
        flag: subList.length == 1 ? true : false
    }, currentRenderData);

    return checkResult;
}

export {
    addSubStackOut
};
